import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LinkOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import type { ChannelConnection } from "@/api/client";
import { useI18n } from "@/i18n";

type Status = ChannelConnection["status"];

// Status is always icon + label, never colour alone (Design Brief §2.4).
const look: Record<Status, { color: string; icon: React.ReactNode }> = {
  connecting: { color: "processing", icon: <SyncOutlined spin /> },
  syncing: { color: "processing", icon: <SyncOutlined spin /> },
  active: { color: "success", icon: <CheckCircleOutlined /> },
  reauth_required: { color: "warning", icon: <LinkOutlined /> },
  error: { color: "error", icon: <ExclamationCircleOutlined /> },
  disconnected: { color: "default", icon: <CloseCircleOutlined /> },
};

export function ConnectionStatus({ status }: { status: Status }) {
  const { t } = useI18n();
  const l = look[status];
  return (
    <Tag color={l.color} icon={l.icon}>
      {t(`channels.status.${status}`)}
    </Tag>
  );
}
